import React from "react";
import {t} from "i18next";
import {Form, Flag, TextArea, Table, Label} from "semantic-ui-react";
import Dialog from "../../../components/Dialogs/Dialog";
import Button from "../../../components/Button";
import {PSLCopyConflictDto, OptionTextDto} from "../../../services/Client";

interface IPSLCopyConflictsDialogProps {
    pslCopyConflictList: PSLCopyConflictDto[];
    pslCopyParams: any;
    onConfirm: () => any;
    onClose: () => any;
}

export const PSLCopyConflictsDialog: React.StatelessComponent<IPSLCopyConflictsDialogProps> = (props: IPSLCopyConflictsDialogProps) => {
    const specificConflictsCount = props.pslCopyConflictList.map((dto: PSLCopyConflictDto) => dto.specificChildrenCount)
        .reduce((a: number, b: number) => {
            return a + b;
        });

    return (
        <Dialog
            title={t("PSL_COPY:PSL_COPY_CONFLICTS_DLG_TITLE")}
            open={true}
            customStyleClassName={"scrollableYDialog"}
            actions={[
                <Button
                    key={"submitButton"}
                    icon={"checkmark"}
                    label={t("GLOBAL:CONFIRM")}
                    onClick={props.onConfirm}
                />,
                <Button
                    key={"cancelButton"}
                    icon={"ban"}
                    label={t("GLOBAL:CANCEL")}
                    onClick={props.onClose}
                />
            ]
            }
        >
            {props.pslCopyConflictList.length > 0 ?
                <>
                    <p>{t("PSL_COPY:PSL_COPY_CONFLICTS_DLG_TEXT", props.pslCopyParams)}</p>
                    <p style={{"marginLeft":"30px"}}><b>{props.pslCopyConflictList.length}</b> {' ' + t("PSL_COPY:BASICMARKET_OPTIONS_CONFLICTS")}</p>
                    <p style={{"marginLeft":"30px"}}><b>{specificConflictsCount}</b> {' ' + t("PSL_COPY:SPECIFIC_OPTIONS_CONFLICTS")}</p>
                    <p>{t("PSL_COPY:PSL_COPY_CONFLICTS_MSG")}</p>

                    <Table celled={true} structured={true}>
                        <Table.Header className={"text-align--center"}>
                            <Table.Row>
                                <Table.HeaderCell>{t("OPTIONS_VIEW:OPTION_CODE")}</Table.HeaderCell>
                                <Table.HeaderCell>{t("OPTIONS_VIEW:SHORTTEXT")}</Table.HeaderCell>
                                <Table.HeaderCell>{t("PSL_COPY:SPECIFIC_CHILDREN_COUNT")}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {props.pslCopyConflictList.map((dto: PSLCopyConflictDto, index: number) => {
                                return (
                                    <Table.Row key={'row-' + index}>
                                        <Table.Cell>
                                            <Label ribbon={true}>
                                                {dto.optionCode + '-' + dto.optionType}
                                            </Label>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form>
                                                <Form.Group widths='equal' key={"formGroup-" + index}>
                                                    {dto.texts.sort((a, b) =>
                                                        (a.language && b.language && a.language.code && b.language.code && a.language.code > b.language.code) ? 1 : -1)
                                                        .map((item: OptionTextDto, idx: number) =>
                                                            <Form.Field
                                                                readOnly={true}
                                                                key={"formField-" + idx}
                                                                label={
                                                                    <Flag
                                                                        className="copyMYOBTextLangFlag"
                                                                        name={item.language && item.language.code === "de" ? "de" : "gb"}
                                                                    />
                                                                }
                                                                control={TextArea}
                                                                value={item.shorttext || ""}
                                                            />
                                                        )}
                                                </Form.Group>
                                            </Form>
                                        </Table.Cell>
                                        <Table.Cell className={"text-align--center"}>
                                            {dto.specificChildrenCount > 0 ?
                                                <b>{dto.specificChildrenCount}</b>
                                                :
                                                dto.specificChildrenCount}
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })
                            }
                        </Table.Body>
                    </Table>
                </>
                :
                <p>{t("PSL_COPY:NO_CONFLICTS", props.pslCopyParams)}</p>
            }
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/PSL/PSLCopyConflictsDialog.tsx